export default [
    {
        path: '/heishop/precios',
        name: 'heishop-precios',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/heishop/Precios.vue')
    },

]